import { render, staticRenderFns } from "./Col12.vue?vue&type=template&id=262bc9c8&scoped=true"
import script from "./Col12.vue?vue&type=script&lang=js"
export * from "./Col12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262bc9c8",
  null
  
)

export default component.exports